import Kichiri from "./KichiriService";
import UserService from "./UserService";

const DataMapperService = {
	/**
	 * The fixed datasource entities + relationships.
	 * @returns {Promise<{entities: Array, relationships: Array}>}
	 */
	async getRegistry() {
		let { authToken } = UserService.getUserData();
		try {
			let response = await Kichiri.data_mapper.registry({}, {}, authToken);
			return response.data || { entities: [], relationships: [] };
		} catch (error) {
			console.log(error);
		}
		return { entities: [], relationships: [] };
	},

	/**
	 * Resolve dropdown options for a datasource entity, optionally filtered by a
	 * parent selection through the fixed (parent -> entity) relationship.
	 * @returns {Promise<Array<{id: string, label: string}>>}
	 */
	async resolveOptions({ entityKey, parentEntityKey, parentId, search }) {
		let { authToken } = UserService.getUserData();
		try {
			let response = await Kichiri.data_mapper.resolve(
				{
					entityKey,
					parentEntityKey: parentEntityKey || null,
					parentId: parentId === undefined ? null : parentId,
					search: search || null,
				},
				{},
				authToken
			);
			return (response.data && response.data.options) || [];
		} catch (error) {
			console.log(error);
		}
		return [];
	},
};

export default DataMapperService;
